<template>
  <div class="card-container flex-start">

    <div class="card two-times">
      <div class="card-header">
        <h4 class="card-title">今月のつぼ</h4>
      </div>
      <div class="card-body">
        <H5><img src="/images/panda-default.gif"><span class="text-bold">{{ current.title }}</span></h5>
        <div v-html="current.body">
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">アーカイブ</h4>
      </div>
      <div class="card-body">
        <ul style="list-style: none;">
          <!--<li v-for="content in contents.slice().reverse()">-->
          <li v-for="(content, index) in contents">
            <a style="text-decoration: none; cursor: pointer;" v-html="content.sub" v-on:click="showItem(index)"></a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        contents: {},
        current: {},
      };
    },
    methods: {
      showItems() {
        console.log(this.contents);
      },
      showItem(index) {
        this.current = this.contents[index];
      }
    },
    mounted() {
      const db = this.$root.firebaseApp.database();
      const contentsRef = db.ref('contents');
      contentsRef.orderByKey().limitToLast(12).once('value', snapshot => {
        this.contents = Object.values(snapshot.val()).reverse();
        this.current = this.contents[0];
      });
    }
  };
</script>



// WEBPACK FOOTER //
// PressurePoint.vue?4c5fc6d4